import { ErrorHandler } from '@angular/core'

declare global {
  interface Window {
    newrelic: any
  }
}

export class GenericErrorHandler implements ErrorHandler {
  handleError(error: any): void {
    const newrelic = window.newrelic || {
      noticeError: () => {
        return
      },
    }
    console.error(error)
    newrelic.noticeError(error)
  }
}
